
import { defineComponent } from 'vue';
import Banner from '@/components/banner/Banner.vue';
import { mapState } from 'vuex';
import FileItem from './downloadcenter/FileItem.vue';
import { getDownloadFileByType } from '@/api/apis';

export default defineComponent({
  name: 'Product',
  components: {
    Banner,
    FileItem
  },
  data() {
    return {
      loading: false,
      loaded: false,
      pageNo: 1,
      pageSize: 3,
      videoPageNo: 1,
      videoPageSize: 3,
      pageSizeOptions: ['3', '6', '12'],
      current: 1,
      total: 0,
      fileList: [],
      videoFileList: [],
      videoTotal: [],
      fileTypes: [
        {
          code: 'download.public_file',
          type: 0
        },
        {
          code: 'download.sale_after_file',
          type: 1
        }
      ],
      selectedType: 0,
      expand: false
    };
  },
  created() {
    this.loadFileList();
    this.loadVideoFileList();
  },
  computed: {
    ...mapState(['lang'])
  },
  watch: {
    lang() {
      this.loadFileList();
      this.loadVideoFileList();
    }
  },
  methods: {
    handleTypeChange(fileType) {
      if (fileType !== this.selectedType) {
        this.selectedType = fileType;
        this.pageNo = 1;
        this.videoPageNo =1;
        this.loadFileList();
        this.loadVideoFileList();
      }
    },
    getTitle() {
      const item = this.fileTypes.find(
        (s: any) => s.type === this.selectedType
      );
      return item ? this.$t(item.code) : '';
    },

    async loadFileList() {
      this.loading = true;
      this.loaded = false;
      const vRes1 = await getDownloadFileByType({
        subType: 1,
        type: this.selectedType,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });

      if (vRes1.success) {
        this.fileList = vRes1.result.records || [];
        this.total = vRes1.result.total;
      }

      this.loading = false;
      this.loaded = true;
    },
    async loadVideoFileList() {
      this.loading = true;
      this.loaded = false;
      const vRes2 = await getDownloadFileByType({
        subType: 2,
        type: this.selectedType,
        pageNo: this.videoPageNo,
        pageSize: this.videoPageSize
      });
      if (vRes2.success) {
        this.videoFileList = vRes2.result.records || [];
        this.videoTotal = vRes2.result.total;
      }
      this.loading = false;
      this.loaded = true;
    },
    onShowSizeChange() {
      this.pageNo = 1;
      this.loadFileList();
    },

    onVideoShowSizeChange() {
      this.videoPageNo = 1;
      this.loadVideoFileList();
    },

    onChange() {
      this.loadFileList();
    },
    onVideoChange() {
      this.loadVideoFileList();
    }
  }
});
